import { Injectable, Injector } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';

import { DATA_INJECTION_TOKEN } from '../../../ngrx/modal/services/modal.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  overlayRef: OverlayRef;
  constructor(
    private readonly overlay: Overlay,
  ) { }

  attachOverlay(component, data): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global(),
      scrollStrategy: this.overlay.scrollStrategies.block()
    });

    const portal = new ComponentPortal(
      component,
      null,
      Injector.create({
        providers: [{ provide: DATA_INJECTION_TOKEN, useValue: data }],
      }),
    );

    this.overlayRef.attach(portal);
  }

  detachOverlay(): void {
    if (!this.overlayRef) {
      return;
    }

    this.overlayRef.detach();
  }
}
